// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1bsb1ejb{width:var(--ds-space-300,24px)}\n._ahbqpxbi{margin-inline-start:var(--ds-space-200,1pc)}", ""]);
// Exports
module.exports = exports;
